import Model, { attr } from '@ember-data/model';

export interface CampaignDashboardPledgesSectionItem {
  pledge_id: number;
  given_amount: number;
  given_gifts_count: number;
  expected_amount: number;
  expected_gifts_count: number;
}

export default class CampaignGoalDashboardModel extends Model {
  @attr('string') campaignGoalId!: string;
  @attr('number') givenAmount!: number;
  @attr('number') givenPercent?: number;
  @attr('date-only') givenToDate?: Date;
  @attr() givenByMonth!: { month: string; amount: number }[];
  @attr('number') notApprovedGivenAmount!: number;
  @attr('number') notApprovedGivenPercent?: number;
  @attr('number') expectingAmount!: number;
  @attr('number') expectingPercent?: number;
  @attr('date-only') expectingFromDate?: Date;
  @attr('number') totalAmount!: number;
  @attr('number') totalPercent?: number;
  @attr('number') leftToRaiseAmount?: number;
  @attr('number') leftToRaisePercent?: number;
  @attr() pledges!: { expecting: CampaignDashboardPledgesSectionItem[] };
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'campaign-goal-dashboard': CampaignGoalDashboardModel;
  }
}
